 
export const ipoInvest = {
  pageTitle: 'Market Linked Debentures - Bidd',
  metaData: {
    keywords: 'Alternate Investment Platform - Best Passive Income Investment',
    description: "Learn more about Market Linked Debentures",
    ogTitle: 'Market Linked Debentures - Bidd',
    ogDescription: "Learn more about Market Linked Debentures",
    ogUrl: process.env.APP_BASE_URL + '/mld',
    ogImgUrl: 'https://s3.ap-south-1.amazonaws.com/production.biddeasy.com/platform/static/images/logo/biddeasy.png?timestamp=' + Date.now()
  },

  ipo: {
    title: "Steps to invest in the NCD IPO?",
    subtitle: "Apply bond IPO in simply steps, No KYC required",

    highlights: [
      {
        step: "Step 1",
        img: process.env.REACT_APP_IMAGES_PATH + "ipo1.webp",
        text: "Select IPO series",
        arrowimg: process.env.REACT_APP_IMAGES_PATH + "arrow.webp"
      },
      {
        step: "Step 2",
        img: process.env.REACT_APP_IMAGES_PATH + "demat.webp",
        text: "Enter demat & Payment details",
        arrowimg: process.env.REACT_APP_IMAGES_PATH + "arrow.webp",
      },
      {
        step: "Step 3",
        img: process.env.REACT_APP_IMAGES_PATH + "upi.webp",
        text: "Accept Payment mandate",
        arrowimg: process.env.REACT_APP_IMAGES_PATH + "arrow.webp"
      },
      {
        step: "Step 4",
        img: process.env.REACT_APP_IMAGES_PATH + "ipo2.webp",
        text: "Get bond IPO units in your demat account",
      }
    ],
    Source_Fold : [
      {
        "Series": "I",
        "Frequency of Interest Payment": "Monthly",
        "Tenor": "18 Months",
        "Coupon (% per annum)": "9.48%",
        "Effective Yield (% per annum)": "9.88%",
        "Tenor and Repayment": "18 Months -Bullet repayment at the end of 18m",
        "Put and Call Option": "Not Applicable"
      },
      {
        "Series": "II",
        "Frequency of Interest Payment": "Quarterly",
        "Tenor": "24 Months",
        "Coupon (% per annum)": "9.55%",
        "Effective Yield (% per annum)": "9.88%",
        "Tenor and Repayment": "24 Months-Staggered Redemption in eight (8) quarterly payments, starting from end of 1st quarter until maturity",
        "Put and Call Option": "Not Applicable"
      },
      {
        "Series": "III",
        "Frequency of Interest Payment": "Monthly",
        "Tenor": "24 Months",
        "Coupon (% per annum)": "9.66%",
        "Effective Yield (% per annum)": "10.08%",
        "Tenor and Repayment": "24 Months-Bullet repayment at the end of 24m",
        "Put and Call Option": "Not Applicable"
      },
      {
        "Series": "IV",
        "Frequency of Interest Payment": "Annual",
        "Tenor": "36 Months",
        "Coupon (% per annum)": "10.30%",
        "Effective Yield (% per annum)": "10.28%",
        "Tenor and Repayment": "36 Months-Staggered Redemption in Three (3) annual payments for year 1, year 2 and year 3 starting from 1st anniversary until Maturity",
        "Put and Call Option": "Not Applicable"
      },
      {
        "Series": "V",
        "Frequency of Interest Payment": "Monthly",
        "Tenor": "36 Months",
        "Coupon (% per annum)": "9.84%",
        "Effective Yield (% per annum)": "10.29",
        "Tenor and Repayment": "36 Months-Bullet repayment at the end of 36m",
        "Put and Call Option": "Not Applicable"
      }
    ],
    IPO_UPI_HANDLES : [
      {
        name: "BHIM Baroda Pay",
        handle: "@BARODAMPAY",
      },
      {
        name: "BHIM RBL Pay",
        handle: "@rbl",
      },
      {
        name: "BHIM PayWiz",
        handle: "@idbi",
      },
      {
        name: "BHIM",
        handle: "@upi",
      },
      {
        name: "BHIM AUPay",
        handle: "@aubank",
      },
      {
        name: "BHIM Axis Pay",
        handle: "@axisbank",
      },
      {
        name: "BHIM BANDHAN UPI",
        handle: "@bandhan",
      },
      {
        name: "BHIM DLB UPI / DhanSmart",
        handle: "@dlb",
      },
      {
        name: "BHIM IndusPay",
        handle: "@indus",
      },
      {
        name: "BHIM KBL UPI",
        handle: "@kbl",
      },
      {
        name: "BHIM Lotza UPI",
        handle: "@federal",
      },
      {
        name: "BHIM SBIPay",
        handle: "@sbi",
      },
      {
        name: "BHIM UCO UPI",
        handle: "@uco",
      },
      {
        name: "BHIM YES PAY",
        handle: "@yesbank",
      },
      {
        name: "Citi Mobile",
        handle: "@citi",
      },
      {
        name: "Citi Mobile",
        handle: "@citigold",
      },
      {
        name: "DigiBank - DBS",
        handle: "@dbs",
      },
      {
        name: "Freecharge",
        handle: "@freecharge",
      },
      {
        name: "Google Pay",
        handle: "@okhdfcbank",
      },
      {
        name: "Google Pay",
        handle: "@okaxis",
      },
      {
        name: "Google Pay",
        handle: "@oksbi",
      },
      {
        name: "Google Pay",
        handle: "@okicici",
      },
      {
        name: "HSBC Simply Pay",
        handle: "@hsbc",
      },
      {
        name: "IDBI Bank GO Mobile+",
        handle: "@idbi",
      },
      {
        name: "iMobile by ICICI Bank",
        handle: "@icici",
      },
      {
        name: "IndOASIS",
        handle: "@indianbank",
      },
      {
        name: "IndOASIS",
        handle: "@allbank",
      },
      {
        name: "Kotak Mobile Banking App",
        handle: "@kotak",
      },
      {
        name: "MobiKwik",
        handle: "@ikwik",
      },
      {
        name: "Nxt - Union Bank of India",
        handle: "@unionbankofindia",
      },
      {
        name: "Nxt - Union Bank of India",
        handle: "@uboi",
      },
      {
        name: "Nxt - Union Bank of India",
        handle: "@unionbank",
      },
      {
        name: "Paytm",
        handle: "@paytm",
      },
      {
        name: "PhonePe",
        handle: "@ybl",
      },
      {
        name: "PhonePe",
        handle: "@axl",
      },
      {
        name: "PhonePe",
        handle: "@ibl",
      },
      {
        name: "SIB Mirror+",
        handle: "@sib",
      },
    ],
  }
}


